import * as Sentry from "@sentry/react";

/**
 * As opções de privacidade do Session Replay abaixo repetem os defaults do SDK
 * DE PROPÓSITO.
 *
 * Elas não são preferência de configuração: são a invariante que a Política de
 * Privacidade (legal/politica-privacidade.md, cl. 2.6) afirma ao usuário — "a
 * gravação de sessão não captura as imagens enviadas aos agentes". A
 * plataforma recebe imagem médica; se o replay capturasse a tela do Preceptor,
 * a promessa de não retenção de imagem cairia por um caminho lateral, com o
 * dado indo parar em operador nos Estados Unidos.
 *
 * Default implícito não sobrevive a um upgrade de major do SDK nem a alguém
 * passar `replayIntegration({ ... })` com outro objetivo e, sem saber, zerar o
 * resto. Declarado, o dia em que isso mudar aparece no diff.
 */
export function initSentry() {
  Sentry.init({
    dsn: "ALTERAR-SEU-SENTRY-DSN",
    
    sendDefaultPii: true,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        // Bloqueia img/svg/video/picture/object/embed e ignora background-image.
        blockAllMedia: true,
        // Redundante com blockAllMedia para a <img> em si, mas ancora o bloqueio
        // no CONTAINER da imagem médica (grid de previews + dropzone), que
        // sobrevive a uma troca de markup. Ver [data-sentry-block] em
        // PreceptorAI e AuthedImage.
        block: [".sentry-block", "[data-sentry-block]"],
      }),
      Sentry.feedbackIntegration({
        colorScheme: "system",
        // O screenshot do widget usa getDisplayMedia: captura a TELA, não o DOM,
        // e blockAllMedia não alcança. Como App.tsx abre este diálogo
        // automaticamente no ErrorBoundary (showDialog), o convite apareceria
        // justamente quando a imagem do paciente ainda está em tela.
        enableScreenshot: false,
      }),
    ],

    _experiments: {
      enableLogs: true,
    },

    tracesSampleRate: 1.0,

    tracePropagationTargets: [/^\//, /^https:\/\/([a-z0-9-]+\.)*app-neuronews\.web\.app/],

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

export { Sentry };
